import {getDataset} from '../../../../../../common/shared/utils/getDataset';
import {getInternalAssetImage} from '../../../../../../design-system/atoms/StaticImage/getInternalAssetImage.function';
import {InternalStaticImageType} from '../../../../../../design-system/atoms/StaticImage/InternalStaticImageType.enum';
import {STATIC_IMAGE_INFO_MAP} from '../../../../../../design-system/atoms/StaticImage/StaticImageInfoMap.constant';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {loadImgElement} from './loadImgElement';

/**
 * ContentElement 내 이미지를 로드하는 프로미스를 반환하는 함수
 *
 * useDummySrc가 true면 크기 반영을 위해 더미 이미지를, false면 원본 이미지를 로드합니다.
 * 이미지 로드하는 개별 프로미스 중 실패하는게 있더라도 일괄 요청된 프로미스는 끝까지 수행됩니다.
 */
export async function loadImagesInContentElement({
  frameElements,
  useDummySrc,
}: {
  frameElements: PartialFrameElements;
  useDummySrc?: boolean;
}) {
  const {contentElement} = frameElements;

  const imgElements = contentElement.querySelectorAll('img');

  const settledResultList = await Promise.allSettled(
    Array.from(imgElements).map(element => {
      const src = useDummySrc
        ? getDataset(element, 'dummySrc')
        : getDataset(element, 'src');
      return loadImgElement({element, src});
    })
  );

  const loadedImgElements: HTMLImageElement[] = [];
  const errors: Error[] = [];
  for (const settledResult of settledResultList) {
    if (settledResult.status === 'fulfilled') {
      loadedImgElements.push(settledResult.value);
    } else {
      const element = settledResult.reason?.element;
      if (element) {
        const loadingImageErrorInfo =
          STATIC_IMAGE_INFO_MAP[
            InternalStaticImageType.LoadingImageErrorWebStatic
          ];
        element.src = getInternalAssetImage(
          loadingImageErrorInfo.srcStatic || ''
        );

        element.setAttribute('data-is-loading-image-error', 'true');
        const fixedWidth = element.getAttribute('data-fixed-width');
        const fixedHeight = element.getAttribute('data-fixed-height');

        // 고정된 사이즈 값이 없으면 에러 이미지의 사이즈를 넣어줍니다.
        element.style.width = fixedWidth || '40px';
        element.style.height = fixedHeight || '40px';
        element.style.objectFit = 'scale-down';
      }

      const error = settledResult.reason?.error;
      if (error) {
        errors.push(error);
      }
    }
  }

  return {
    loadedImgElements,
    errors,
  };
}
